export default {
    USER_BLOCKED_SUCCESSFULLY: "Пользователь успешно заблокирован",
    USERS_BLOCKED_SUCCESSFULLY: "Пользователи успешно заблокированы",
    USER_UNBLOCKED_SUCCESSFULLY: "Пользователь успешно разблокирован",
    USERS_UNBLOCKED_SUCCESSFULLY: "Пользователи успешно разблокированы",
    USER_REMOVED_SUCCESSFULLY: "Пользователь успешно удален",
    USERS_REMOVED_SUCCESSFULLY: "Пользователи успешно удалены",
    USER_SAVED_SUCCESSFULLY: "Пользователь успешно сохранен"
};
